/**
 * BACK-02/BACK-05 — acesso mínimo ao `window.history`, injetável para testes.
 * Só o gerenciador de overlays usa este adaptador (allowlist BACK-18).
 */
export interface HistoryAdapter {
  getState(): unknown
  /** Empurra uma entrada com a URL atual. */
  pushState(state: unknown): void
  go(delta: number): void
  /** Registra listener de `popstate` em fase de captura; devolve o cleanup. */
  addPopStateListener(fn: (event: PopStateEvent) => void): () => void
}

export const browserHistoryAdapter: HistoryAdapter = {
  getState: () => (typeof window === 'undefined' ? null : window.history.state),
  pushState: (state) => {
    window.history.pushState(state, '')
  },
  go: (delta) => {
    window.history.go(delta)
  },
  addPopStateListener: (fn) => {
    if (typeof window === 'undefined') return () => {}
    window.addEventListener('popstate', fn, { capture: true })
    return () => window.removeEventListener('popstate', fn, { capture: true })
  },
}
